/*
  Offer values hint: the macro also works in lead form templates.
  Merged FIRST into TRANSLATION_MAPS in ./index.js. Keys are the English source.
*/

const ru = {
  "Named key/value pairs injected into landing/offer/postback URLs and lead form templates via the {offer_value:NAME} macro.": "Именованные пары ключ/значение, подставляемые в URL лендинга/оффера/постбэка и в шаблоны лид-формы через макрос {offer_value:NAME}.",
};

const es = {
  "Named key/value pairs injected into landing/offer/postback URLs and lead form templates via the {offer_value:NAME} macro.": "Pares clave/valor con nombre que se inyectan en las URLs de landing/oferta/postback y en las plantillas del formulario de leads mediante la macro {offer_value:NAME}.",
};

const pt = {
  "Named key/value pairs injected into landing/offer/postback URLs and lead form templates via the {offer_value:NAME} macro.": "Pares chave/valor nomeados injetados nas URLs de landing/oferta/postback e nos modelos do formulário de leads via macro {offer_value:NAME}.",
};

const de = {
  "Named key/value pairs injected into landing/offer/postback URLs and lead form templates via the {offer_value:NAME} macro.": "Benannte Schlüssel/Wert-Paare, die über das Makro {offer_value:NAME} in Landing-/Offer-/Postback-URLs und in Vorlagen des Lead-Formulars eingesetzt werden.",
};

const fr = {
  "Named key/value pairs injected into landing/offer/postback URLs and lead form templates via the {offer_value:NAME} macro.": "Paires clé/valeur nommées insérées dans les URL de landing/offre/postback et dans les modèles du formulaire de leads via la macro {offer_value:NAME}.",
};

const it = {
  "Named key/value pairs injected into landing/offer/postback URLs and lead form templates via the {offer_value:NAME} macro.": "Coppie chiave/valore con nome inserite negli URL di landing/offerta/postback e nei template del form lead tramite la macro {offer_value:NAME}.",
};

const pl = {
  "Named key/value pairs injected into landing/offer/postback URLs and lead form templates via the {offer_value:NAME} macro.": "Nazwane pary klucz/wartość wstawiane do adresów URL landingu/oferty/postbacku i do szablonów formularza leadów przez makro {offer_value:NAME}.",
};

const tr = {
  "Named key/value pairs injected into landing/offer/postback URLs and lead form templates via the {offer_value:NAME} macro.": "{offer_value:NAME} makrosuyla landing/offer/postback URL'lerine ve lead formu şablonlarına eklenen adlandırılmış anahtar/değer çiftleri.",
};

const uk = {
  "Named key/value pairs injected into landing/offer/postback URLs and lead form templates via the {offer_value:NAME} macro.": "Іменовані пари ключ/значення, що підставляються в URL лендингу/оферу/постбеку та в шаблони лід-форми через макрос {offer_value:NAME}.",
};

const OFFER_VALUES_LEAD = { ru, es, pt, de, fr, it, pl, tr, uk };
export default OFFER_VALUES_LEAD;
